<template>
  <div id="app">
    <Header></Header>
    <main class="site-main">
      <router-view/>
      <Footer></Footer>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.site-main {
  min-height: 100vh;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue